import { FormikConsumer, FormikContext } from 'formik'
import { FormikCheckbox, FormikTextField } from 'formik-office-ui-fabric-react'
import { FieldStack, FieldStackItem, FormStack } from 'forms/FormStack'
import { Box } from 'grid'
import { GdprRuleInsertType } from 'model'
import { Label } from 'office-ui-fabric-react'
import * as React from 'react'
import { useTranslation } from 'react-i18next'
import * as Yup from 'yup'

export class CreateRuleFormSchema {
  constructor() {
    return Yup.object().shape({
      ruleName: Yup.string().required(),
      retentionPeriod: Yup.number()
        .required()
        .min(0, 'Eingegebener Wert muss mindestens 0 betragen.'),
      deletionPeriod: Yup.number()
        .required()
        .min(0, 'Eingegebener Wert muss mindestens 0 betragen.'),
    })
  }
}

export type CreateRuleFormValues = GdprRuleInsertType
export const CreateRuleFormWithContext: React.FC<
  FormikContext<CreateRuleFormValues>
> = (ctx) => {
  const { t } = useTranslation()
  return (
    <FormStack>
      <FieldStack>
        <FieldStackItem
          name="ruleName"
          required={true}
          label={t('field.ruleName.label')}
          placeholder={t('field.ruleName.placeholder')}
          component={FormikTextField}
        />
        <FieldStackItem
          name="retentionPeriod"
          label={t('field.retentionPeriod.controlLabel')}
          required={true}
          component={FormikTextField}
          type="number"
          placeholder={t('field.retentionPeriod.placeholder')}
        />
        <FieldStackItem
          name="deletionPeriod"
          label={t('field.deletionPeriod.controlLabel')}
          required={true}
          component={FormikTextField}
          type="number"
          placeholder={t('field.deletionPeriod.placeholder')}
        />
        {ctx.values._id && (
          <FieldStackItem
            stack={{ grow: 0 }}
            name="inactive"
            render={(fieldProps) => (
              <>
                <Label>{t('field.inactive.label')}</Label>
                <Box py={1}>
                  <FormikCheckbox {...fieldProps} />
                </Box>
              </>
            )}
          />
        )}
      </FieldStack>
    </FormStack>
  )
}

export const CreateRuleForm: React.FunctionComponent = () => (
  <FormikConsumer>
    {(ctx) => <CreateRuleFormWithContext {...ctx} />}
  </FormikConsumer>
)
